<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <product-category-form v-if="productCat"
          @submit="submit"
          :init-product-category="productCat"
          :val-errors="valErrors"
          :product-categories="productCategories"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import ProductCategoryForm from './product-category-form'

export default {
  components: { ProductCategoryForm },
  data () {
    return {
      productCat: null,
      productCategories: [],
      valErrors: []
    }
  },
  methods: {
    async submit (productCat) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/product_categories/${productCat.id}`, productCat).then(({ data }) => {
        this.$notify({
          message: 'Produktkategorie erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/product_categories')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    const id = this.$route.params.id

    this.$http.get(`/product_categories?onlyParents&exclude=${id}`).then(({ data }) => {
      this.productCategories = data
    })
    this.$http.get(`/product_categories/${id}`).then(({ data }) => {
      this.productCat = data
    })
  }
}
</script>

<style>
</style>
